import { useEffect, useId, useRef } from 'react'
import { createPortal } from 'react-dom'

export function ReturnToExpertConfirmation({ busy, feedback, returnFocus, onCancel, onConfirm }: {
  busy: boolean
  feedback: string
  returnFocus: HTMLButtonElement | null
  onCancel: () => void
  onConfirm: () => Promise<void>
}) {
  const dialog = useRef<HTMLDialogElement>(null)
  const id = useId()
  useEffect(() => {
    const element = dialog.current!
    element.showModal()
    return () => { element.close(); returnFocus?.focus() }
  }, [returnFocus])
  return createPortal(<dialog ref={dialog} className="review-confirmation"
    aria-labelledby={`${id}-title`} aria-describedby={`${id}-description`}
    onCancel={event => { event.preventDefault(); if (!busy) onCancel() }}>
    <h2 id={`${id}-title`}>Return to expert execution?</h2>
    <p id={`${id}-description`}>The expert can revise the task and execution, with everyone’s quality-check feedback available.
      Their updated submission will go through peer review, task package build, and quality check again.</p>
    <p className="small muted">Existing files, builds, and review history will be kept. The current package pull request will be closed.</p>
    <div className="review-confirmation-feedback">
      <h3>Your feedback</h3>
      <p className="prewrap">{feedback}</p>
    </div>
    <div className="row">
      <button autoFocus disabled={busy} onClick={onCancel}>Cancel</button>
      <button className="primary" disabled={busy} onClick={() => void onConfirm()}>
        {busy ? 'Returning…' : 'Confirm return'}
      </button>
    </div>
  </dialog>, document.body)
}
